import React from "react"

import "./bg.css"

function Backgorund() {
  return (
    <React.Fragment>
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
      <div className="shooting_star" />
    </React.Fragment>
  )
}

export default Backgorund